import type {
  GlobalContextAction,
  GlobalContextReducerState
} from './reducers/types';

export interface GlobalContextProviderProps {
  children: React.ReactNode;
  initialValue?: GlobalContextReducerState;
}

export enum ContextAction {
  setLayout = 'SET_LAYOUT',
  setLang = 'SET_LANG',
  setUser = 'SET_USER',
  resetUser = 'RESET_USER',
  setToast = 'SET_TOAST',
  setNavbarState = 'SET_NAVBAR',
  setPermissions = 'SET_PERMISSIONS',
  resetPermissions = 'RESET_PERMISSIONS',
  setRouteConfig = 'SET_ROUTE_CONFIG',
  setCaseHistory = 'SET_CASE_HISTORY',
  resetCaseHistory = 'RESET_CASE_HISTORY',
  setActiveFeatureConfig = 'SET_ACTIVE_FEATURE_CONFIG'
}

export interface GlobalContextState {
  state: GlobalContextReducerState;
  dispatch: React.Dispatch<GlobalContextAction>;
}
